import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { SpedFixedUserPermission, SpedUserPermission } from '../../../sped-user-permissions.model';
import { Sped360Service } from '../../../sped360.service';
import { SpedStudentCollectionCard } from '../../../student-document-home/sped-student-document-cards/sped-student-document-cards.model';
import { FormWithinDocumentsService } from '../../form-within-documents.service';
import { OptionalForms, TeamMemberPermission } from '../../formwithin-document-modal';

@Component({
  selector: 'app-add-optional-forms',
  templateUrl: './add-optional-forms.component.html',
  styleUrls: ['./add-optional-forms.component.css']
})
export class AddOptionalFormsComponent implements OnInit {
  dialogTitle = '';
  tempStudentCollectionId: number;
  collectionId: number;
  collectionCode: string;
  hasPermission: boolean;
  tylerMatData = new TylerMatTableDataSource();
  getOptionalForms: OptionalForms[] = [];
  collectionCard = new SpedStudentCollectionCard();
  columnToDisplay = ['CheckAllStatus', 'TemplateName', 'Version', 'IsOptional', 'IsAllowMultiple'];
  allCheck = false;
  isTeamMemberPer: boolean;
  TemplateVersionId: number;
  assignedTemplateVersionIds: number[] = [];
  spedFixedPermission = new SpedFixedUserPermission();
  spedUserPermission: SpedUserPermission[] = [];
  selectedOptionalForm: TeamMemberPermission[] = [];
  spEdcollectionId: number;
  tempStudentId: number;
  tempOptionalForms: OptionalForms[] = [];

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private formWithinDocumentsService: FormWithinDocumentsService,
    private dialogRef: MatDialogRef<AddOptionalFormsComponent>,
    private sped360Service: Sped360Service) { }

  ngOnInit(): void {
    this.spedFixedPermission = this.sped360Service.spedFixedPermission;
    this.spedUserPermission = this.sped360Service.spedUserPermission;
    this.getAllOptionalForm();
    // this.getSelectedOptionalFormMethod();
  }
  getAllOptionalForm() {
    this.formWithinDocumentsService.spedEditAssignedCollectionTemplatesRead(this.tempStudentCollectionId, this.collectionId).subscribe(formList => {
      this.getOptionalForms = formList;
      this.getSelectedOptionalForm();
    });
  }
  closeClick() {
    this.dialogRef.close();
  }

  saveClick() {
    this.dialogRef.close('save');
  }

  setSelectedForm() {
    this.getOptionalForms.forEach(setForm => {
      this.selectedOptionalForm.forEach(selectedSetForm => {
        if (setForm.TemplateVersionId == selectedSetForm.SpedTemplateVersionId && selectedSetForm.IsEdit == true) {
          this.tempOptionalForms.push(setForm);
        }
      });
    });
    this.tylerMatData = new TylerMatTableDataSource(this.tempOptionalForms);
    this.tylerMatData.data = this.tempOptionalForms;
    this.tylerMatData.sort = this.sort;
  }

  checkPermission() {
    if ((!this.collectionCode.includes('504') && this.spedFixedPermission.MaintainAllSpEdDocuments) || (this.collectionCode.includes('504') && this.spedFixedPermission.MaintainAll504Documents)) {
      return true;
    } else if (this.spedUserPermission.filter(x => x.CollectionId == this.collectionId && x.Maintain == true).length > 0) {
      return true;
    }
    else {
      return false;
    }
  }
  getSelectedOptionalForm() {
    if (this.checkPermission() == true) {
      this.getOptionalFormsList();
    } else if (this.isTeamMemberPer == true) {
      this.formWithinDocumentsService.teamMemberPermissionRead(this.tempStudentCollectionId, this.tempStudentId).subscribe(data => {
        this.selectedOptionalForm = data;
        this.tylerMatData.data = this.selectedOptionalForm;
        this.tylerMatData.sort = this.sort;
        this.setSelectedForm();
      });
    }

  }

  getOptionalFormsList() {
    this.tempOptionalForms = this.getOptionalForms;
    this.tylerMatData = new TylerMatTableDataSource(this.getOptionalForms);
    this.tylerMatData.data = this.getOptionalForms;
    this.tylerMatData.sort = this.sort;
  }

  checkBoxClick(obj: OptionalForms) {
    if (this.tempOptionalForms.length == this.tempOptionalForms.filter(x => x.StatusChecked == true).length) {
      this.allCheck = true;
    } else if (this.tempOptionalForms.length != this.tempOptionalForms.filter(x => x.StatusChecked == true).length) {
      this.allCheck = false;
    }
    this.assignSelectedForms(obj);
  }

  assignSelectedForms(obj: OptionalForms) {
    const assignTemplateVersionId = obj.TemplateVersionId;
    if (obj.StatusChecked == true) {
      this.assignedTemplateVersionIds.push(assignTemplateVersionId);
    } else if (obj.StatusChecked == false) {
      const index: number = this.assignedTemplateVersionIds.indexOf(obj.TemplateVersionId);
      this.assignedTemplateVersionIds.splice(index, 1);
    }
  }

  checkAllForm() {
    if (this.allCheck == true) {
      if (this.selectedOptionalForm.length == 0) {
        this.getOptionalForms.forEach(obj => {
          obj.StatusChecked = true;
          const assignTemplateVersionId = obj.TemplateVersionId;
          this.assignedTemplateVersionIds.push(assignTemplateVersionId);
        });
      }
      else {
        this.tempOptionalForms.forEach(obj => {
          obj.StatusChecked = true;
          const assignTemplateVersionId = obj.TemplateVersionId;
          this.assignedTemplateVersionIds.push(assignTemplateVersionId);

        });
      }
    } else if (this.allCheck == false) {
      this.getOptionalForms.forEach(obj => {
        obj.StatusChecked = false;
        const index: number = this.assignedTemplateVersionIds.indexOf(obj.TemplateVersionId);
        this.assignedTemplateVersionIds.splice(index, 1);
      });
    }

  }
}
